










import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class DadosCidadeComplemento extends Vue {
    get cidadecomplemento () {
        return this.$store.state.cotacao.cidadecomplemento;
    }

    set cidadecomplemento ( value ) {
        this.$store.commit("SET_CIDADECOMPLEMENTO", value);
    }

    get errorCidadeComplemento () {
        return this.$store.state.errors.cidadecomplemento;
    }

    public onChange () {
        this.$store.dispatch("VALIDAR_DADOS")
            .then()
            .catch(() => { return; });
    }
}
